module.exports = __webpack_public_path__ + "static/img/img.796c33e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/img.svg
// module id = HnV6
// module chunks = 1